import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuoteLeft, faStar, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';

import testimonials from './data';
import Card, { CardBody } from '../../components/Card';
import './testimonials.css';

const Testimonials = () => {
  return (
    <section className="testimonials section section--surface" id="testimonials">
      <div className="container">
        {/* Section Header */}
        <div className="testimonials__header" data-aos="fade-up">
          <h2 className="testimonials__title">Apa Kata Pelanggan Kami</h2>
          <p className="testimonials__subtitle">
          Lihat pengalaman pelanggan yang telah mempercayakan servis perangkat Apple mereka bersama iTech Service.
          </p>
          
          {/* Rating Overview */}
          <div className="testimonials__rating" data-aos="fade-up" data-aos-delay="100">
            <div className="testimonials__rating-score">
              <span className="testimonials__rating-number">4.9</span>
              <div className="testimonials__rating-stars">
                {[...Array(5)].map((_, i) => (
                  <FontAwesomeIcon 
                    key={i} 
                    icon={faStar} 
                    className="testimonials__star" 
                  />
                ))}
              </div>
            </div>
            <div className="testimonials__rating-text">
              <span>Berdasarkan 500+ ulasan</span>
            </div>
          </div>
        </div>

        {/* Testimonials Carousel */}
        <div className="testimonials__carousel" data-aos="fade-up" data-aos-delay="200">
          <Swiper
            modules={[Pagination, Autoplay, Navigation]}
            spaceBetween={30}
            slidesPerView={1}
            centeredSlides={true}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            pagination={{
              clickable: true,
              bulletClass: 'testimonials__pagination-bullet',
              bulletActiveClass: 'testimonials__pagination-bullet--active',
            }}
            navigation={{
              nextEl: '.testimonials__nav-next',
              prevEl: '.testimonials__nav-prev',
            }}
            loop={true}
            breakpoints={{
              576: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 30,
              },
              992: {
                slidesPerView: 3,
                spaceBetween: 30,
              },
              1200: {
                slidesPerView: 3,
                spaceBetween: 40,
              },
            }}
            className="testimonials__swiper"
          >
            {testimonials.map((testimonial, index) => (
              <SwiperSlide key={testimonial.id}>
                <Card 
                  variant="testimonial" 
                  className="testimonials__card"
                  data-aos="fade-up"
                  data-aos-delay={300 + (index * 100)}
                >
                  <CardBody className="testimonials__content">
                    {/* Quote Icon */}
                    <div className="testimonials__quote-icon">
                      <FontAwesomeIcon icon={faQuoteLeft} />
                    </div>
                    
                    {/* Rating */}
                    <div className="testimonials__card-rating">
                      {[...Array(5)].map((_, i) => (
                        <FontAwesomeIcon 
                          key={i} 
                          icon={faStar} 
                          className="testimonials__card-star" 
                        />
                      ))}
                    </div>
                    
                    {/* Testimonial Text */}
                    <p className="testimonials__text">
                      {testimonial.status}
                    </p>
                    
                    {/* Customer Info */}
                    <div className="testimonials__customer">
                      <div className="testimonials__customer-avatar">
                        <img 
                          src={testimonial.avatar} 
                          alt={`${testimonial.name} - Pelanggan iTech Service`}
                          loading="lazy" 
                        />
                      </div>
                      <div className="testimonials__customer-details">
                        <h4 className="testimonials__customer-name">
                          {testimonial.name}
                        </h4>
                        <span className="testimonials__customer-role">
                          Pelanggan Terverifikasi
                        </span>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </SwiperSlide>
            ))}
          </Swiper>
          
          {/* Navigation Buttons */}
          <div className="testimonials__navigation">
            <button 
              className="testimonials__nav-btn testimonials__nav-prev"
              aria-label="Testimoni sebelumnya"
            >
              <FontAwesomeIcon icon={faChevronLeft} />
            </button>
            <button 
              className="testimonials__nav-btn testimonials__nav-next"
              aria-label="Testimoni selanjutnya"
            >
              <FontAwesomeIcon icon={faChevronRight} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
